import { FC,useEffect,useState } from "react"
import { useParams } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "@/core/app/hooks"
import GeneralClinicalDialog from "./GeneralClinicalDialog"
import {
  undoRefinement
} from "@/core/app/slices/clinical/refinement/refinementThunkApi"
import{
  deleteAllCaseZips
} from "@/core/app/slices/clinical/clinicalworkflow"
import {
  setReuploadSelfPlan
} from "@/UDTreat/udTreatSlice"
import { caseConversionAction } from "@/core/app/slices/case/caseThunkApi"
import { CASE_ACTION } from "@/core/constants/caseActionType"
import { useNavigate } from "react-router-dom"


/**
 * usage: depend on the global state 'isReuploadSelfPlan' to show reupload dialog or not, 
 *        need to pass lockFunc to lock the case when re-uploading.
 * @param lockFunc  lock the case when re-uploading
 * @returns 
 */
const ReuploadForSelfPlan: FC<{
  lockFunc: any;
}> = ({ lockFunc }) => {

  const { caseId, patientId } = useParams()
  const dispatch = useAppDispatch()

  const [showReuploadDlg, setShowReuploadDlg] = useState(false)
  const [showRefinementDlg, setShowRefinementDlg] = useState(false)

  const {isReuploadSelfPlan,onConfirm} = useAppSelector((state) => state.udTreatService.reuploadSelfPlan)
  const {refinementNum} = useAppSelector((state) => state.udTreatService)

  const navigate = useNavigate()

  useEffect(() => {
    if(isReuploadSelfPlan){
      refinementNum > 1 ? setShowRefinementDlg(true) : setShowReuploadDlg(true)
    }else{
      refinementNum > 1 ? setShowRefinementDlg(false) : setShowReuploadDlg(false)
    }
  }, [isReuploadSelfPlan])

  return <>
        <GeneralClinicalDialog
        isShow={showReuploadDlg}
        title={"Are you sure you want to re-upload the scans?"}
        cancelText={"Cancel"}
        confirmText={"Yes, re-upload the scans"}
        cancelAction={() => {
          dispatch(setReuploadSelfPlan({isReuploadSelfPlan:false}))
          }
        }
        confirmAction={async () => {
          lockFunc(async ()=>{
            // clear case data
            await dispatch(deleteAllCaseZips({
              caseId,
              patientId,
            }))
            // reset case status
            await dispatch(caseConversionAction({ patientId, caseId, payload: { action: CASE_ACTION.REUPLAD_SCANS}}))

            // close this dialog
            await dispatch(setReuploadSelfPlan({isReuploadSelfPlan:false}))
          
            navigate(
              `/records/patient/${patientId}/case/${caseId}/scans?mode=redopresetup`,
            )
          })
        }}
      />
      <GeneralClinicalDialog
        isShow={showRefinementDlg}
        title={
          "Software will remove the current refinement for you,  then you can restart the refinement process to upload the new scan files Proceed?"
        }
        cancelText={"No"}
        confirmText={"YES"}
        cancelAction={() => {
            dispatch(setReuploadSelfPlan({isReuploadSelfPlan:false})) 
          }
        }
        confirmAction={async () => {
          lockFunc(async ()=>{
            // close this dialog
            dispatch(setReuploadSelfPlan({isReuploadSelfPlan:false}))

            // undo refinement
            await dispatch(undoRefinement({
              caseId,
              patientId,
              lockFunc
            }))

            // reset case status
            await dispatch(caseConversionAction({ patientId, caseId, payload: { action: CASE_ACTION.REUPLOAD_SCANS_FOR_SELF_REFINEMENT}}))

            onConfirm();
          })
        }}
      />
  </>

}


export default ReuploadForSelfPlan